module.exports = __webpack_public_path__ + "img/development-during-recession-top.fdaba242.webp";